import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { Ref } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteQueryKeys } from "@/data/api/site-query-keys";
import { SiteProgrammingRangeQueryKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-query-keys";
import { SiteSectionMutationKeys } from "@/data/api/v4b/site-section/site-section-mutation-keys";
import { SiteSectionId, V4HSiteId } from "@/data/common/ids";
import { MoveSectionRequest } from "@/domains/v4b/site-section/site-section.types";

export function useMoveSectionMutation(siteId: Ref<V4HSiteId>, sectionId: Ref<SiteSectionId | undefined>) {
  const v4b = useServices().v4b.clientSdk;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: sectionId.value ? SiteSectionMutationKeys.move(sectionId.value) : undefined,
    mutationFn: (command: MoveSectionRequest) => {
      if (!sectionId.value) {
        throw new Error("Section ID is required");
      }

      return v4b.siteSection.move(sectionId.value, command);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: SiteQueryKeys.sections(siteId),
      });

      await queryClient.removeQueries({
        queryKey: SiteProgrammingRangeQueryKeys.findPlanning(siteId),
      });
    },
    retry: 0,
  });
}
